<template>
    <div
        class="col-12 col-lg-8 col-md-4 position-relative"
    >
        <div class="w-0 my-2 mx-2 mx-lg-0 mx-md-0">
            <div :class="{'position-absolute select-label fs-7': isStyled}" v-if="label.length" :style="{backgroundColor: bgColor}">
                {{ label }}
            </div>
            <div class="rounded-0 w-100 p-2 fs-6 bg-transparent border border-2" 
                style="border: 2px solid rgba(0,0,0,0.2) !important;">
                {{item.title}} <span v-if="skuLabel.length">({{skuLabel}})</span>
            </div>
        </div>
    </div>
    <div class="col-6 col-lg-4 col-md-4">
        <!-- <SelectDesign label="Qty" bgColor="#F9F7F3" v-model="selectQty" :list="qtyList" /> -->
        <SelectedInputV2 label="Qty" bgColor="#F9F7F3" v-model="selectQty" textClass="fw-bolder" />
    </div>
</template>

<script setup>
import { useVModel } from "@/fuel-station/useVModel";

const props = defineProps({
    modelValue: {
        type: [Object, Array, String],
        default: {
            id: 0,
            name: "Select One"
        },
    },
    item: {
        type: Object,
        default: null,
    },
    label: {
        type: String,
        default: ""
    },
    isStyled: {
        type: Boolean,
        default: true
    },
    bgColor: {
        type: String,
        default: "#fff"
    }
});

const emit = defineEmits(['update:modelValue']);
const modelValueRef = useVModel(props, emit, "modelValue");

const qtyList = ref([
    {
        id: "qty0",
        name: 0,
        // selected: true,
    },
    {
        id: "qty1",
        name: 1,
    },
    {
        id: "qty2",
        name: 2,
    },
    {
        id: "qty3",
        name: 3,
    },
    {
        id: "qty4",
        name: 4,
    },
    {
        id: "qty5",
        name: 5,
    },
]);
// const selectQty = ref(qtyList.value[0]);
const selectQty = ref(0);

const skuLabel = computed(() => {
    if (props.item?.skus?.length) {
        return props.item?.skus[0]?.label?.length && props.item?.skus[0]?.label != "base" ? props.item.skus[0]?.label : "";
    }
    return "";
})

watch(selectQty,
    (newVal) => {
        // if (selectQty.value?.name > 0) {
        //     modelValueRef.value = {
        //         item: props.item,
        //         sku: props.item?.skus[0],
        //         quantity: selectQty.value?.name,
        //     }
        // }
        if (selectQty.value > 0) {
            modelValueRef.value = {
                item: props.item,
                sku: props.item?.skus[0],
                quantity: selectQty.value,
            }
        }
    },
    { immediate: true, deep: true }
);
</script>

<style lang="scss" scoped>
.select-label {
    top: -10px;
    left: 13px;
    z-index: 99;
    padding: 0 5px;
}


.form-select:focus {
    border-color: none !important;
    box-shadow: none !important;
}
</style>